import { useCallback, useMemo } from "react";

import styles from "./EventSwitch.module.css";

import { eventType, EventType } from "../../../services/models/event";
import { Switch, TabItem } from "../../shared/Switch/Switch";

interface EventSwitchProps {
    value: EventType;
    onChangeType: (type: EventType) => void;
}

export const EventSwitch = (props: EventSwitchProps) => {
    const { onChangeType, value } = props;

    const SwitchTabs: TabItem[] = useMemo(
        () =>
            Object.values(eventType).map((type) => ({
                value: type,
                content: type === "event" ? "Событие" : "ДПО",
            })),
        [],
    );

    const onTabClick = useCallback(
        (tab: TabItem) => {
            onChangeType(tab.value as EventType);
        },
        [onChangeType],
    );

    return (
        <div className={styles.eventSwitch}>
            <Switch onTabClick={onTabClick} tabs={SwitchTabs} value={value} label="Выберите категорию события" />
        </div>
    );
};
